import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

const ACTION_PREFIX = "[Iaui verification]";

export const IAUI_VERIFICATION_ACTION_TYPE = {
	openModal: `${ACTION_PREFIX} Open Modal ${SYNC_SUFFIX}`,
	closeModal: `${ACTION_PREFIX} Close Modal ${SYNC_SUFFIX}`,
	dismissNotification: `${ACTION_PREFIX} Dismiss notification ${SYNC_SUFFIX}`,
	clearPaymentType: `${ACTION_PREFIX} Clear PaymentType ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class IauiVerificationAction {
	openModal(): Action {
		return {
			type: IAUI_VERIFICATION_ACTION_TYPE.openModal,
		};
	}

	dismissNotification(): Action {
		return {
			type: IAUI_VERIFICATION_ACTION_TYPE.dismissNotification,
		};
	}

	closeModal(selectedPayment?: string): ActionWithPayload {
		return {
			type: IAUI_VERIFICATION_ACTION_TYPE.closeModal,
			payload: selectedPayment,
		};
	}

	clearPaymentType(): Action {
		return {
			type: IAUI_VERIFICATION_ACTION_TYPE.clearPaymentType,
		};
	}
}
